import type React from 'react';

function BudbeeLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 982.1 244.6"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Budbee Logo</title>

      <g id="Layer_2-2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <g>
            <path
              d="M79.6,83.6c-16.2,0-33.1,6.6-43.1,16.4l-1.7,1.6-2,2.2V0H0V241.4H32.8v-17.2l2,2.4,1.7,1.6c9.9,9.9,26.5,16.4,43.1,16.4,43.1,0,79.5-32.9,79.5-80.5s-36.5-80.5-79.5-80.5Zm-1.7,131.5c-28.1,0-48-23-48-50.9s19.9-51,48-51c31.5,0,48,23,48,51s-16.5,50.9-48,50.9Z"
              fill="inherit"
            />
            <path
              d="M278.3,180.5c-1,19.1-17.2,34.5-36.4,34.5-22.2,0-32.5-11.8-33.1-32.9V86.8h-33.1v95.3c0,36.2,23.2,62.5,62.9,62.5,13.2,0,29.8-6.6,36.4-16.4l1.7-2.2,1.7-2.3v17.7h33.1V86.9h-33.1v93.6h-.1Z"
              fill="inherit"
            />
            <path
              d="M745.3,83.6c-43.1,0-76.2,32.9-76.2,80.5s34.8,80.5,76.2,80.5c31.5,0,54.6-16.4,67.9-39.4l-27.8-13.1c-5,13.1-18.5,23-38.4,23-28.2,0-44.7-19.7-44.7-42.7h115.9v-9.9c-.1-47.7-33.2-78.9-72.9-78.9h0Zm-41.4,59.8c5-17.1,18.2-30.2,41.4-30.2,19.9,0,36.4,13.1,38.1,30.2h-79.5Z"
              fill="inherit"
            />
            <path
              d="M909.2,83.6c-43.1,0-76.2,32.9-76.2,80.5s34.8,80.5,76.2,80.5c31.5,0,54.6-16.4,67.9-39.4l-27.8-13.1c-5,13.1-18.5,23-38.4,23-28.1,0-44.7-19.7-44.7-42.7h115.9v-9.9c-.1-47.7-33.2-78.9-72.9-78.9h0Zm-41.4,59.8c5-17.1,18.2-30.2,41.4-30.2,19.9,0,36.4,13.1,38.1,30.2h-79.5Z"
              fill="inherit"
            />
            <path
              d="M579.7,83.6c-16.2,0-33.1,6.6-43.1,16.4l-1.7,1.6-2,2.2V0h-32.8V241.4h32.8v-17.2l2,2.4,1.7,1.6c9.9,9.9,26.5,16.4,43.1,16.4,43.1,0,79.5-32.9,79.5-80.5s-36.5-80.5-79.5-80.5Zm-1.7,131.5c-28.1,0-48-23-48-50.9s19.9-51,48-51c31.5,0,48,23,48,51s-16.5,50.9-48,50.9Z"
              fill="inherit"
            />
            <path
              d="M324.7,164.1c0,47.7,36.4,80.5,79.5,80.5,16.6,0,33.1-6.6,43.1-16.4l1.7-1.6,2-2.4v17.2h32.8V0h-33V103.8l-2-2.2-1.7-1.6c-9.9-9.9-26.8-16.4-43.1-16.4-42.9,0-79.3,32.8-79.3,80.5Zm33.1,0c0-27.9,16.6-51,48-51,28.1,0,48,23,48,51s-19.9,50.9-48,50.9c-31.5,.1-48-22.9-48-50.9Z"
              fill="inherit"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BudbeeLogo;
